export default __webpack_public_path__ + "static/DonMitchell-349b6fc5b3a9885ac0c26a8dd4d0a6b7.jpg";